window.addEventListener("DOMContentLoaded", (event) => {
  let trunc_agents = document.querySelectorAll(".trunc-agent");
  let trunc_carets = document.querySelectorAll(".trunc-caret");
  for (let trunc of [...trunc_agents, ...trunc_carets]) {
    trunc.addEventListener("click", (e) => {
      e.stopPropagation();
      let trunc_patients = document.querySelectorAll(`.trunc-patient[data-trunc-select="${trunc.dataset.truncSelect}"]`)
      for (let truncp of trunc_patients) {
        if (trunc.dataset.truncOption === truncp.dataset.truncOption)
          truncp.classList.remove("trunc");
        else truncp.classList.add("trunc");
      }

      let trunccs = document.querySelectorAll(`.trunc-caret[data-trunc-select="${trunc.dataset.truncSelect}"]`)
      for (let truncc of trunccs) {
        if (trunc.dataset.truncOption === truncc.dataset.truncOption)
          truncc.classList.remove("trunc");
        else truncc.classList.add("trunc");
      }
    });
  }

  let instructions_modals = document.querySelectorAll(".instructions-modal");
  let instructions_modal_btns = document.querySelectorAll(".instructions-modal-btn");
  let shopify_section = document.querySelectorAll("#MainContent > .shopify-section"); // fixes the modal overlapping problem
  // give all instruction buttons their own custom click events
  for (let btn of instructions_modal_btns) {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      for (let section of shopify_section) section.classList.add("p-static"); // convert the shopify-section make its position static
      let modals = document.querySelectorAll(`.instructions-modal[data-modal-name=${btn.dataset.modalName}`);
      for (let modal of modals) {
        modal.classList.remove("hidden");
        let closers = modal.querySelectorAll(".modal-close");
        for (let closer of closers) closer.addEventListener("click", (e) => {
          for (let section of shopify_section) section.classList.remove("p-static"); // revert to normal
          modal.classList.add("hidden");
        });
      }
    });
  }
  window.addEventListener("click", (e) => {
    for (let modal of instructions_modals) if (e.target == modal) modal.classList.add("hidden");
  });

  let instruction_videos = document.querySelectorAll(".instruction-video");
  let instruction_iframes= document.querySelectorAll(".instruction-iframe");

  let modal_closes = document.querySelectorAll(".modal-close");
  for (let pauser of modal_closes) {
    pauser.addEventListener("click", e => {
      for (let video of instruction_videos) {
        video.pause();
        video.currentTime = 0;
      }
      for (let video of instruction_iframes) {
        var iframeSrc = video.src;
		video.src = iframeSrc;
      }
    });
  }
  let instructions_modal_closes = document.querySelectorAll(".instructions-modal");
  for (let instructions_pauser of instructions_modal_closes) {
    instructions_pauser.addEventListener("click", e => {
      for (let instructions_video of instruction_videos) {
        instructions_video.pause();
        instructions_video.currentTime = 0;
      }
      for (let video of instruction_iframes) {
        var iframeSrc = video.src;
		video.src = iframeSrc;
      }
    });
  }
  let tablinks = document.querySelectorAll(".tablinks");
  for (let pauser of tablinks) {
    pauser.addEventListener("click", e => {
      for (let video of instruction_videos) video.pause();
    });
  }

  // ===== Find in Store — collapsed disclosure over the store locator widget =====
  let storeLocatorRoot = document.getElementById("storelocators_root");
  if (storeLocatorRoot) {
    let storeLocatorSection = storeLocatorRoot.closest(".shopify-section");
    if (storeLocatorSection) {
      storeLocatorSection.classList.add("storelocator-collapsed");

      let toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "find-in-store-toggle";
      toggle.setAttribute("aria-expanded", "false");
      toggle.innerHTML = `
        <svg class="fis-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
          <path d="M3 9.5 12 3l9 6.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 9v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="fis-text">
          <span class="fis-title">Find in Store</span>
          <span class="fis-subtitle">Check local dealer inventory</span>
        </span>
        <svg class="fis-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      let toggleWrap = document.createElement("div");
      toggleWrap.className = "container";
      toggleWrap.appendChild(toggle);

      storeLocatorSection.parentNode.insertBefore(toggleWrap, storeLocatorSection);

      toggle.addEventListener("click", () => {
        let stillCollapsed = storeLocatorSection.classList.toggle("storelocator-collapsed");
        toggle.setAttribute("aria-expanded", stillCollapsed ? "false" : "true");
      });
    }
  }
});

function openFile(evt, fileName, mtype) {
  let tabcontents = document.querySelectorAll(`.tabcontent[data-mtype=${mtype}]`);
  for (let tc of tabcontents) {
    if (tc.id === fileName) {
      tc.classList.remove("hidden");
      tc.classList.add("flex");
      continue;
    }
    tc.classList.remove("flex");
    tc.classList.add("hidden");
  }

  let tablinks = document.getElementsByClassName("tablinks");
  for (let tl of tablinks) tl.classList.remove("active");
  evt.currentTarget.classList.add("active");
}

$(document).ready(function () {
    $('.slide-article_row').slick({
    dots: false,
    arrows: true,
    prevArrow:"<button type='button' class='slide-article_arrow slide-article-left'> << </button>",
    nextArrow:"<button type='button' class='slide-article_arrow slide-article-right'> >> </button>",
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
 });



$(document).ready(function () {
    $('.article_main').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
 });

$(window).scroll(function () {
  if ($(window).scrollTop() >= 500) {
    $(".header").addClass("header_animate");
  } else {
    $(".header").removeClass("header_animate");
  }
});

$(window).scroll(function() {

    var main_height = $('.hero-main').height();	
     var st = $(this).scrollTop(); 
  
  if( st >= main_height ) {
    $(".hero-main").removeClass("hero-fixed-main");
    $(".hero-wrapper").removeClass("hero-fixed");
  } else {
    $(".hero-main").addClass("hero-fixed-main");
    $(".hero-wrapper").addClass("hero-fixed");
  }
});

$(window).scroll(function () {
  if ($(window).scrollTop() >= 900) {
    $(".header").addClass("header_animate2");
  } else {
    $(".header").removeClass("header_animate2");
  }
});
$(window).scroll(function () {
  if ($(window).scrollTop() >= 2000) {
    $(".header").addClass("header_animate3");
  } else {
    $(".header").removeClass("header_animate3");
  }
});
$(window).scroll(function () {
  if ($(window).scrollTop() >= 3000) {
    $(".header").addClass("header_animate4");
  } else {
    $(".header").removeClass("header_animate4");
  }
});

$(window).scroll(function () {
  if ($(window).scrollTop() >= 4000) {
    $(".header").addClass("header_animate5");
  } else {
    $(".header").removeClass("header_animate5");
  }
});

$(document).ready(function () {
  $(".brand_col").slick({
    dots: true,
    infinite: false,
    speed: 300,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  //search
  $(".header__search a").click(function (e) {
    //     e.stopPropagation();
    $(".header__search_desktop").toggleClass("is_visible");
    //     $('.header__search_desktop .search_bar__input').focus();
  });
});

$(document).ready(function () {
  
  // header js
  let mouseover_timeout_id = 0;
  let mouseleave_timeout_id = 0;
  let timeout_duration = 500; // the time it takes before the mouseleave and mouseover triggers

  $(".main-menu__nav-item").mouseover(function () {
    clearTimeout(mouseover_timeout_id);  // these 2 lines will cancel the timeout to prevent
    clearTimeout(mouseleave_timeout_id); //     reexecuting the hover
    mouseover_timeout_id = setTimeout(() => {
      let menu_title = $(this).data('menutitle');
      if (!$(this).hasClass('limenu_open')) {
        let current_link = $(this);
        $(this).parents(".main-menu__nav").addClass("menu_active");
        $(".menu-dropdown__content").removeClass("prevcome");
        $(".menu-dropdown__content").removeClass("nextcome");     
        if($(this).parents(".main-menu__nav").hasClass('menu_active')){
          $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").prevAll().addClass("prevdiv");
          $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").prevAll().removeClass("nextdiv");
          $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").nextAll().addClass("nextdiv");
          $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").nextAll().removeClass("prevdiv");
          $(".menu-dropdown__content").addClass("block_megamenu");
          if($(".menu-dropdown__content[data-megamenu='"+menu_title+"']").hasClass('prevdiv')){
            $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").addClass('prevcome');
          }
          if($(".menu-dropdown__content[data-megamenu='"+menu_title+"']").hasClass('nextdiv')){
            $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").addClass('nextcome');
          }
        }
        $(".main-menu__nav-item").removeClass("limenu_open");
        $(".menu-dropdown__content").removeClass("menu_top");
        $(".menu-dropdown__content").removeClass("open_megamenu");
        $(current_link).addClass("limenu_open");
        $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").addClass("open_megamenu"); 
        $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").removeClass("prevdiv");  
        $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").removeClass("nextdiv"); 
        $(".header-inner-megamenu").find('.menu-dropdown__content').not($(".menu-dropdown__content[data-megamenu='"+menu_title+"']")).addClass("slide_megamenu");
        $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").removeClass("slide_megamenu");
        $(".header").addClass("smoll_hed");
        $("body").addClass("fixed_megamenu");
      } else {
        // the following will close the menu dropdown if it's already open
        $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").delay(5000).removeClass("open_megamenu");           
        $(".header").removeClass("smoll_hed");
        $(".main-menu__nav").removeClass("menu_active");
        $("body").removeClass("fixed_megamenu");      
        $(this).removeClass("limenu_open");
        $(".menu-dropdown__content[data-megamenu='"+menu_title+"']").delay(5000).removeClass("block_megamenu");      
        $(".menu-dropdown__content").removeClass("prevcome");
        $(".menu-dropdown__content").removeClass("nextcome"); 
        $(".menu-dropdown__content").removeClass("prevdiv");
        $(".menu-dropdown__content").removeClass("nextdiv");
        $(".menu-dropdown__content").addClass("menu_top");
      }
    }, timeout_duration);
  });

  $(".header-wrap").mouseleave(function(e) {
    clearTimeout(mouseover_timeout_id);  // these 2 lines will cancel the timeout to prevent
    clearTimeout(mouseleave_timeout_id); //     reexecuting the hover
    mouseleave_timeout_id = setTimeout(function() { 
      $(".menu-dropdown__content").removeClass("open_megamenu");
      $(".header").removeClass("smoll_hed");
      $(".main-menu__nav").removeClass("menu_active");
      $("body").removeClass("fixed_megamenu");
      $(".main-menu__nav-item").removeClass("limenu_open");
      $(".menu-dropdown__content").removeClass("block_megamenu");
      $(".menu-dropdown__content").removeClass("slide_megamenu");
      $(".menu-dropdown__content").removeClass("prevcome");
      $(".menu-dropdown__content").removeClass("nextcome");
      $(".menu-dropdown__content").removeClass("prevdiv");
      $(".menu-dropdown__content").removeClass("nextdiv");
      $(".menu-dropdown__content").addClass("menu_top");
    }, timeout_duration);
  });

  $(".single-option-selector").hover(function(){
      $(this).parents(".product-form__item").find(".curr_val").hide();
      var data = $(this).parents(".product-form__item").find(".single-option-selector input:checked").val();
      var val = $(this).parents(".product-form__item").find(".opt_title").html(data);
  });
  
  $(".play_button.play svg").click(function () {
    $(this).hide(), $(this).parents(".video_hold ").find("video").get(0).play();
    $(".gr_1").addClass("video_shedow");
  });
  $(".video_hold  video").click(function () {
    $(".play_button svg").show(), $(this).parents(".video_hold ").find("video").get(0).pause();
    $(".gr_1").removeClass ("video_shedow");
  });
  
});